'use client';

import s from 'Workadabra/app/[lang]/home/sections/how-it-works/styles.module.css';
import {
  rdHowHeading,
  rdHowSub,
  rdProvidersTag,
  rdProvidersTitle,
  rdProvStep1Body,
  rdProvStep1Title,
  rdProvStep2Body,
  rdProvStep2Title,
  rdProvStep3Body,
  rdProvStep3Title,
  rdSeekersTag,
  rdSeekersTitle,
  rdSeekStep1Body,
  rdSeekStep1Title,
  rdSeekStep2Body,
  rdSeekStep2Title,
  rdSeekStep3Body,
  rdSeekStep3Title,
} from 'Workadabra/translations';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

export const HowItWorksSection = () => {
  const params = useParams();
  const language = getLanguageFromLocale(params?.lang as string);

  const tracks = [
    {
      steps: [
        { body: rdSeekStep1Body[language], title: rdSeekStep1Title[language] },
        { body: rdSeekStep2Body[language], title: rdSeekStep2Title[language] },
        { body: rdSeekStep3Body[language], title: rdSeekStep3Title[language] },
      ],
      tag: rdSeekersTag[language],
      testId: 'track-seekers',
      title: rdSeekersTitle[language],
    },
    {
      steps: [
        { body: rdProvStep1Body[language], title: rdProvStep1Title[language] },
        { body: rdProvStep2Body[language], title: rdProvStep2Title[language] },
        { body: rdProvStep3Body[language], title: rdProvStep3Title[language] },
      ],
      tag: rdProvidersTag[language],
      testId: 'track-providers',
      title: rdProvidersTitle[language],
    },
  ];

  return (
    <section className={s.root} data-testid='how-it-works-section' id='how-it-works'>
      <div className={s.head}>
        <h2 className={s.heading}>{rdHowHeading[language]}</h2>
        <p className={s.sub}>{rdHowSub[language]}</p>
      </div>
      <div className={s.tracks}>
        {tracks.map(track => (
          <div className={s.track} data-testid={track.testId} key={track.testId}>
            <h3 className={s.trackTitle}>{track.title}</h3>
            <p className={s.tag}>{track.tag}</p>
            {track.steps.map((step, i) => (
              <div className={i === 0 ? s.stepFirst : s.step} data-testid={`${track.testId}-step-${i + 1}`} key={step.title}>
                <div className={s.num}>{i + 1}</div>
                <div>
                  <p className={s.stepTitle}>{step.title}</p>
                  <p className={s.stepBody}>{step.body}</p>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
